import cx from 'classnames';
import type { ReactNode } from 'react';
import React from 'react';

export interface TileListProps {
	children: ReactNode;
	marginTop?: 's' | 'm' | 'l';
	customClasses?: string;
}

const marginClasses = {
	s: 'mt-(--templates-margin-s)!',
	m: 'mt-(--templates-margin-m)!',
	l: 'mt-(--templates-margin-l)!',
} as const;

export const Tiles = ({
	children,
	marginTop,
	customClasses,
}: TileListProps) => (
	<ul
		className={cx(
			'gov-list--plain',
			marginTop ? marginClasses[marginTop] : null,
			customClasses
		)}>
		{children}
	</ul>
);
